export default __webpack_public_path__ + "images/direccion-de-atencion-a-personas-migrantes-logo.bfcecb6d6fde007bf8085bbc959fca94.png";